import { ImageNew } from '@jfs/ui-new'
import React, { useEffect, useState } from 'react'
import { Animated, ImageStyle } from 'react-native'
interface AnimatedImageProp {
  src: string
  width: number
  resizeMode?: 'cover' | 'contain' | 'stretch' | 'repeat' | 'center'
  height?: number
  animateFromLeft?: boolean
  expandAnimation: boolean
  collapseAnimation: boolean
}
const AnimatedDevice = (props: AnimatedImageProp) => {
  const { animateFromLeft, src, resizeMode, height, width, expandAnimation, collapseAnimation } = props
  const [animatedValue] = useState<any>(new Animated.Value(0))

  const startAnimation = () => {
    Animated.timing(animatedValue, {
      toValue: collapseAnimation ? 0 : 1,
      duration: 1000,
      useNativeDriver: true,
    }).start()
  }

  const animate = {
    transform: [
      {
        translateX: animatedValue.interpolate({
          inputRange: [1, 2],
          outputRange: [animateFromLeft ? 64 : -64, 0],
        }),
      },
    ],
  }

  useEffect(() => {
    if (expandAnimation || collapseAnimation) {
      startAnimation()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expandAnimation, collapseAnimation])

  return (
    <Animated.View style={[animate]}>
      <ImageNew {...styles(width, height).imageStyle} source={src} resizeMode={resizeMode} />
    </Animated.View>
  )
}

const styles = (width: number, height: number | undefined) => {
  return {
    imageStyle: {
      width: width,
      height: height,
      resizeMode: 'stretch',
      flex: 1,
      marginLeft: 0,
    } as ImageStyle,
  }
}

export { AnimatedDevice }
